import { FormErrors } from "@repo/shared-types";
import { Error } from "./error";

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  description?: React.ReactNode;
  errors?: FormErrors;
}

export function Checkbox({
  label,
  description,
  errors,
  ...props
}: CheckboxProps) {
  const showError = errors?.[props.name ?? ""];
  return (
    <div className="flex flex-col gap-1">
      <label className="flex gap-2 items-center" htmlFor={props.name}>
        <input type="checkbox" {...props} />
        <span className="text-sm text-gray-700">{label}</span>
      </label>
      {description && (
        <span className="text-sm text-gray-500">{description}</span>
      )}
      {showError && <Error fieldName={props.name} errors={errors} />}
    </div>
  );
}
